// extracted by mini-css-extract-plugin
export var sbShowMain = "testimonial-module--sb-show-main--1qFEx";
export var buttonsContainer = "testimonial-module--buttonsContainer--38uc9";
export var btn = "testimonial-module--btn--1dgR-";
export var testimonialListingContainer = "testimonial-module--testimonialListingContainer--2wFk_";
export var testimonial = "testimonial-module--testimonial--168lE";
export var body = "testimonial-module--body--3FwWE";